import { type FC, type ReactNode } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Stack, Text } from '@eneco/sparky';

import { type FormattedValue } from './PriceDetails.types';

const normalizeEuroInText = (text: string): string => text.replace('€ ', '€&nbsp;');

interface DetailValueRowProps {
  text?: string;
  value?: FormattedValue;
  highlightText?: boolean;
  highlightValue?: boolean;
  formatValue: (value: FormattedValue) => string;
  icon?: ReactNode;
  textSize?: 'BodyS' | 'BodyXS';
  textColor?: 'textSecondary' | 'textLowEmphasis';
}

export const DetailValueRow: FC<DetailValueRowProps> = ({
  text,
  value,
  highlightText = false,
  highlightValue = false,
  formatValue,
  icon,
  textSize = 'BodyS',
  textColor,
}) => (
  <Stack direction="row" alignY="center" gap={icon ? '2' : undefined}>
    {text && (
      <Stack.Item grow={typeof value !== 'string'}>
        <Stack direction="row" alignY="center" gap="2">
          {icon}
          <Text size={textSize} weight={highlightText ? 'bold' : 'regular'} color={textColor}>
            <RichText html={normalizeEuroInText(text)} />
          </Text>
        </Stack>
      </Stack.Item>
    )}
    {(value === 0 || value) && (
      <Stack.Item shrink={false} grow={typeof value === 'string'}>
        <Text weight={highlightValue || highlightText ? 'bold' : 'regular'} align="right">
          {formatValue(value)}
        </Text>
      </Stack.Item>
    )}
  </Stack>
);
